import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolOverviewCourses = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            alt="LingualBox Courses"
            width={270}
            height={211}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
            className="flex-image"
            src="/images/courses.png"
          />
        </div>
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.overview.explanations.title.variousCourses')}
          </h2>
          <p className="school-section-description">
            {t('service.school.overview.explanations.detail.variousCourses')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolOverviewCourses;
